module.exports = __webpack_public_path__ + "static/media/video-slash-solid.4bff58bd.svg";